export const districts = {
    'ashburton' : 'Ashburton',
'auckland-city' : 'Auckland City',
'banks-peninsula' : 'Banks Peninsula',
'buller' : 'Buller',
'carterton' : 'Carterton',
'central-hawkes-bay' : 'Central Hawkes Bay',
'central-otago' : 'Central Otago',
'christchurch-city' : 'Christchurch City',
'clutha' : 'Clutha',
'dunedin-city' : 'Dunedin City',
'far-north' : 'Far North',
'franklin-auckland' : 'Franklin-Auckland',
'franklin-waikato' : 'Franklin-Waikato',
'gisborne-district' : 'Gisborne District',
'gore' : 'Gore',
'grey' : 'Grey',
'hamilton-city' : 'Hamilton City',
'hastings' : 'Hastings',
'hauraki' : 'Hauraki',
'horowhenua' : 'Horowhenua',
'hurunui' : 'Hurunui',
'invercargill-city' : 'Invercargill City',
'kaikoura' : 'Kaikoura',
'kaipara' : 'Kaipara',
'kapiti-coast' : 'Kapiti Coast',
'lower-hutt-city' : 'Lower Hutt City',
'mackenzie' : 'Mackenzie',
'manawatu' : 'Manawatu',
'manukau-' : 'Manukau ',
'marlborough-district' : 'Marlborough District',
'masterton' : 'Masterton',
'matamata-piako' : 'Matamata-Piako',
'napier-city' : 'Napier City',
'nelson-city' : 'Nelson City',
'new-plymouth' : 'New Plymouth',
'north-shore-city' : 'North Shore City',
'opotiki' : 'Opotiki',
'otorohanga' : 'Otorohanga',
'palmerston-north-city' : 'Palmerston North City',
'papakura' : 'Papakura',
'porirua-city' : 'Porirua City',
'queenstown-lakes' : 'Queenstown-Lakes',
'rangitikei' : 'Rangitikei',
'rodney' : 'Rodney',
'rotorua' : 'Rotorua',
'ruapehu' : 'Ruapehu',
'selwyn' : 'Selwyn',
'south-taranaki' : 'South Taranaki',
'south-waikato' : 'South Waikato',
'south-wairarapa' : 'South Wairarapa',
'southland-district' : 'Southland District',
'stratford' : 'Stratford',
'tararua' : 'Tararua',
'tasman-district' : 'Tasman District',
'taupo' : 'Taupo',
'tauranga-city' : 'Tauranga City',
'thames-coromandel' : 'Thames-Coromandel',
'timaru-district' : 'Timaru District',
'upper-hutt-city' : 'Upper Hutt City',
'waiheke' : 'Waiheke',
'waikato-district' : 'Waikato District',
'waimakariri' : 'Waimakariri',
'waimate' : 'Waimate',
'waipa' : 'Waipa',
'wairoa' : 'Wairoa',
'waitakere-city' : 'Waitakere City',
'waitaki-canterbury' : 'Waitaki-Canterbury',
'waitaki-otago' : 'Waitaki-Otago',
'waitomo' : 'Waitomo',
'wellington-city' : 'Wellington City',
'western-bay-of-plenty' : 'Western Bay of Plenty',
'westland' : 'Westland',
'whakatane' : 'Whakatane',
'whanganui' : 'Whanganui',
'whangarei' : 'Whangarei',
};